import {
  CREATE_STORYBOARD_REQUEST, CREATING_STORYBOARD_SUCCEEDED, CREATING_STORYBOARD_FAILED,
  UPDATE_STORYBOARD_REQUEST, UPDATING_STORYBOARD_SUCCEEDED, UPDATING_STORYBOARD_FAILED,
  FETCH_STORYBOARDS_REQUEST, FETCHING_STORYBOARDS_SUCCEEDED, FETCHING_STORYBOARDS_FAILED,
  FETCH_STORYBOARD_REQUEST, FETCHING_STORYBOARD_SUCCEEDED, FETCHING_STORYBOARD_FAILED,
  DELETE_STORYBOARD_REQUEST, DELETING_STORYBOARD_SUCCEEDED, DELETING_STORYBOARD_FAILED,
  CLONE_STORYBOARD_REQUEST, CLONING_STORYBOARD_SUCCEEDED, CLONING_STORYBOARD_FAILED,
  FETCH_STORYBOARD_USERS, FETCHING_STORYBOARD_USERS_SUCCEEDED, FETCHING_STORYBOARD_USERS_FAILED,
  ADD_USERS_TO_STORYBOARD, ADD_USERS_TO_STORYBOARD_SUCCEEDED, ADD_USERS_TO_STORYBOARD_FAILED,
  UPDATE_STORYBOARD_USER_ACCESS, UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED, UPDATE_STORYBOARD_USER_ACCESS_FAILED,
  REMOVE_USER_FROM_STORYBOARD, REMOVE_USER_FROM_STORYBOARD_SUCCEEDED, REMOVE_USER_FROM_STORYBOARD_FAILED,
  SET_STORYBOARD_USER_ROLE, INVALIDATE_STORYBOARD_STATE, UPDATE_APPEARANCE_REQUEST,
  UNPUBLISH_PAGE_REQUEST, UNPUBLISHING_PAGE_SUCCEEDED, UNPUBLISHING_PAGE_FAILED, INVALIDATE_UNPUBLISH_PAGE, INVALIDATE_STORYBOARDS_STATE,
  MAKE_HOME_PAGE_FOR_STORYBOARD, MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED, MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED,
  FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD, FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED, FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED,
  FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD, FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED, FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED,

  CREATE_GATING_CONFIG_REQUEST, UPDATE_GATING_CONFIG_REQUEST, DELETE_GATING_CONFIG_REQUEST,

  INITIATE_PPT_UPLOAD_FOR_STORYBOARD, UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS,
  CREATE_STORYBOARD_FROM_PPT_REQUEST, CREATING_STORYBOARD_FROM_PPT_SUCCEEDED, CREATING_STORYBOARD_FROM_PPT_FAILED, 
  CREATE_STORYBOARD_FROM_FIGMA_REQUEST, CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED, CREATING_STORYBOARD_FROM_FIGMA_FAILED,
} from 'constants/actionTypes';

import { call, put, takeEvery, select } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const STORYBOARD_URL = `${apiUrl}/api/2.0/storyboards`;
const PAGE_URL = `${apiUrl}/api/2.0/pages`;
const WIDGET_URL = `${apiUrl}/api/1.0/widgets`;
const FIGMA_BASE_URL = `${apiUrl}/api/1.0/integrations/figma`;

/**
 * Create storyboard for user
*/
export const createStoryboard = createAction(CREATE_STORYBOARD_REQUEST, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
})

export const createStoryboardSucceeded = createAction(CREATING_STORYBOARD_SUCCEEDED, (response) => {
  return response;
})

export const createStoryboardFailed = createAction(CREATING_STORYBOARD_FAILED, (error) => {
  return error;
})

function* createStoryboardSaga(action) {
  const { request, callback } = action.payload;

  const createStoryboardAPI = () => {
    return axios.post(STORYBOARD_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createStoryboardAPI);
    if (response) {
      yield put(createStoryboardSucceeded(response));
      if (callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(createStoryboardFailed(error));
  }
}

/**
 * Update storyboard for user
*/
export const updateStoryboard = createAction(UPDATE_STORYBOARD_REQUEST, (id, request, callback) => {
  return {
    id: id,
    request: request,
    callback: callback
  }
})

export const updateStoryboardSucceeded = createAction(UPDATING_STORYBOARD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

export const updateStoryboardFailed = createAction(UPDATING_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* updateStoryboardSaga(action) {
  const { id, request, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `/${id}`
  });

  const gatingConfigurations =  yield select(state => {
    return _.get(state, `storyboards.storyboard.item.gatingConfigurations`, []);
  });

  var storyboardRequest = _.cloneDeep(request);

  if(gatingConfigurations.length > 0) {
    storyboardRequest = {
      ...storyboardRequest,
      gatingConfigurations: gatingConfigurations.map(item => {
        return {
          ...item,
          gating: _.get(item, 'gating.id', null),
          page: _.get(item, 'page.id', null),
          target: item.target ? { 
            id: _.get(item, 'target.id', null), 
            type:  _.get(item, 'target.entityType', null) || _.get(item, 'target.type', null)
          } : null
        }
      })
    }
  }

  if (gatingConfigurations.length == 0) {
    storyboardRequest = {
      ...storyboardRequest,
      gatingConfigurations: []
    }
  }

  const updateStoryboardAPI = () => {
    return axios.put(url, storyboardRequest).then(response => response.data);
  }

  try {
    const response = yield call(updateStoryboardAPI);
    if (response) {
      yield put(updateStoryboardSucceeded(id, response));

      if (callback) {
        callback();
      }
    }
  } catch (error) {
    yield put(updateStoryboardFailed(id, error));
  }
}

/**
 * Fetch storyboards for user
*/
export const fetchStoryboards = createAction(FETCH_STORYBOARDS_REQUEST, (request) => {
  return request;
});

const fetchingStoryboardsSucceeded = createAction(FETCHING_STORYBOARDS_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  };
});

const fetchingStoryboardsFailed = createAction(FETCHING_STORYBOARDS_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  };
});

function* fetchStoryboardsSaga(action) {
  const request = action.payload;

  const fetchStoryboardsAPI = () => {
    return axios.post(`${STORYBOARD_URL}/search`, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardsAPI);
    yield put(fetchingStoryboardsSucceeded(request, response));
  } catch (error) {
    yield put(fetchingStoryboardsFailed(request, error));
  }
}

/**
 * Fetch storyboard for user
*/
export const fetchStoryboard = createAction(FETCH_STORYBOARD_REQUEST);

const fetchingStoryboardSucceeded = createAction(FETCHING_STORYBOARD_SUCCEEDED, (response) => {
  return response;
});

const fetchingStoryboardFailed = createAction(FETCHING_STORYBOARD_FAILED, (error) => {
  return error;
});

function* fetchStoryboardSaga(action) {
  const id = action.payload;

  const fetchStoryboardAPI = () => {
    return axios.get(`${STORYBOARD_URL}/${id}`).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardAPI);
    yield put(fetchingStoryboardSucceeded(response));
  } catch (error) {
    yield put(fetchingStoryboardFailed(error));
  }
}

/**
 * Delete storyboard 
*/
export const deleteStoryboard = createAction(DELETE_STORYBOARD_REQUEST, (id) => {
  return id;
})

export const deleteStoryboardSucceeded = createAction(DELETING_STORYBOARD_SUCCEEDED, (id) => {
  return id;
})

export const deleteStoryboardFailed = createAction(DELETING_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* deleteStoryboardSaga(action) {
  const id = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: id
  });

  const deleteStoryboardAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    yield call(deleteStoryboardAPI);
    yield put(deleteStoryboardSucceeded(id));
  } catch (error) {
    yield put(deleteStoryboardFailed(id, error));
  }
}

/**
 * Clone storyboard
*/
export const cloneStoryboard = createAction(CLONE_STORYBOARD_REQUEST, (id, list) => {
  return {
    id: id,
    list: list
  };
})

export const cloningStoryboardSucceeded = createAction(CLONING_STORYBOARD_SUCCEEDED, (response) => {
  return response;
})

export const cloningStoryboardFailed = createAction(CLONING_STORYBOARD_FAILED, (error) => {
  return error;
})

function* cloneStoryboardSaga(action) {
  const { id, list } = action.payload;

  const params = {
    list: list
  };

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/clone`,
    queryParams: params
  });

  const cloneStoryboardAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(cloneStoryboardAPI);
    if (response) {
      yield put(cloningStoryboardSucceeded(response));
    }
  } catch (error) {
    yield put(cloningStoryboardFailed(error));
  }
}

/**
 * Fetch users for storyboard
*/
export const fetchStoryboardUsers = createAction(FETCH_STORYBOARD_USERS, (id, request) => {
  return {
    id: id,
    request: request
  }
})

const fetchStoryboardUsersSucceeded = createAction(FETCHING_STORYBOARD_USERS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

const fetchStoryboardUsersFailed = createAction(FETCHING_STORYBOARD_USERS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchStoryboardUsersSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/users/search`
  });

  const fetchStoryboardUsersAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardUsersAPI);
    yield put(fetchStoryboardUsersSucceeded(id, response));
  } catch (error) {
    yield put(fetchStoryboardUsersFailed(id, error));
  }
}

/**
 * Add users to storyboard
*/
export const addUsersToStoryboard = createAction(ADD_USERS_TO_STORYBOARD, (id, request, callback) => {
  return {
    id: id,
    request: request,
    callback: callback
  }
})

const addUsersToStorybordSucceeded = createAction(ADD_USERS_TO_STORYBOARD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const addUsersToStoryboardFailed = createAction(ADD_USERS_TO_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* addUsersToStoryboardSaga(action) {
  const { id, request, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/users`
  });

  const addUsersToStoryboardAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(addUsersToStoryboardAPI);
    yield put(addUsersToStorybordSucceeded(id, response));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(addUsersToStoryboardFailed(id, error));
  }
}

/**
 * update Storyboard user access
*/
export const updateStoryboardUserAccess = createAction(UPDATE_STORYBOARD_USER_ACCESS, (id, request, callback) => {
  return {
    id: id,
    request: request,
    callback: callback
  }
})

const updateStoryboardUserAccessSucceeded = createAction(UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const updateStoryboardUserAccessFailed = createAction(UPDATE_STORYBOARD_USER_ACCESS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* updateStoryboardUserAccessSaga(action) {
  const { id, request, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `user-access/${id}`
  });

  const updateStoryboardUserAccessAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateStoryboardUserAccessAPI);
    yield put(updateStoryboardUserAccessSucceeded(id, response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(updateStoryboardUserAccessFailed(id, error));
  }
}

/**
 * Remove user from storyboard
*/
export const removeUserFromStoryboard = createAction(REMOVE_USER_FROM_STORYBOARD, (id, callback) => {
  return {
    id: id,
    callback: callback
  };
})

const removeUserFromStoryboardSucceeded = createAction(REMOVE_USER_FROM_STORYBOARD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const removeUserFromStoryboardFailed = createAction(REMOVE_USER_FROM_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* removeUserFromStoryboardSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `user-access/${id}`
  });

  const removeUserFromStoryboardAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(removeUserFromStoryboardAPI);
    yield put(removeUserFromStoryboardSucceeded(id, response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(removeUserFromStoryboardFailed(id, error));
  }
}

/**
 * Update storyboard user role
*/
export const setStoryboardUserRole = createAction(SET_STORYBOARD_USER_ROLE, (userId, role) => {
  return {
    userId: userId,
    role: role
  }
})



/**
 * Make Page as Home Page from storyboard
*/
export const makeHomePageForStoryboard = createAction(MAKE_HOME_PAGE_FOR_STORYBOARD, (id, page) => {
  return {
    id: id,
    page: page
  };
})

const makeHomePageForStoryboardSucceeded = createAction(MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED, (id, page, response) => {
  return {
    id: id,
    page: page,
    response: response
  };
})

const makeHomePageForStoryboardFailed = createAction(MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED, (id, page, error) => {
  return {
    id: id,
    page: page,
    error: error
  };
})

function* makeHomePageForStoryboardSaga(action) {
  const { id, page, callback } = action.payload;

  const params = {
    page: page
  }

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/home`,
    queryParams: params
  });

  const makeHomePageForStoryboardAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(makeHomePageForStoryboardAPI);
    yield put(makeHomePageForStoryboardSucceeded(id, page, response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(makeHomePageForStoryboardFailed(id, error));
  }
}

/**
 * Update interactive appearance
*/
export const updateAppearance = createAction(UPDATE_APPEARANCE_REQUEST, (storyboard, request) => {
  return {
    id: storyboard,
    appearance: request
  }
})

/**
 * Create Gating Config
*/
export const createGatingConfig = createAction(CREATE_GATING_CONFIG_REQUEST, (request) => {
  return request;
})

/**
 * Update Gating Config
*/
export const updateGatingConfig = createAction(UPDATE_GATING_CONFIG_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  };
})

/**
 * Delete Gating Config
*/
export const deleteGatingConfig = createAction(DELETE_GATING_CONFIG_REQUEST, (id) => {
  return {
    id : id
  };
})


/**
 * Unpublish page
*/
export const unPublishPage = createAction(UNPUBLISH_PAGE_REQUEST, (id) => {
  return {
    id: id
  }
})

const unPublishPageSucceeded = createAction(UNPUBLISHING_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const unPublishPageFailed = createAction(UNPUBLISHING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* unPublishPageSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}/unpublish`
  });

  const unPublishPageAPI = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then(response => response.data);
  }

  try {
    const response = yield call(unPublishPageAPI);
    yield put(unPublishPageSucceeded(id, response));
    if (callback) yield call(callback, response);
  } catch (error) {
    yield put(unPublishPageFailed(id, error));
  }
}

export const invalidateStoryboardState = createAction(INVALIDATE_STORYBOARD_STATE);
export const invalidateStoryboardsState = createAction(INVALIDATE_STORYBOARDS_STATE);
export const invalidateUnpublishPage = createAction(INVALIDATE_UNPUBLISH_PAGE);


/**
 * Fetch pages for landing page
*/
export const fetchAllPagesForLandingStoryboard = createAction(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD, (request) => {
  return request;
});

const fetchingAllPagesForLandingStoryboardSuccedded = createAction(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED, (response, storyboard) => {
  return {
    storyboard: storyboard,
    response: response
  }
});

const fetchingAllPagesForLandingStoryboardFailed = createAction(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED, (error, storyboard) => {
  return {
    error: error,
    storyboard: storyboard
  };
});

function* fetchAllPagesForLandingStoryboardSaga(action) {
  const request = action.payload;

  const fetchPagesForStoryboardAPI = () => {
    return axios.post(`${PAGE_URL}/search`, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchPagesForStoryboardAPI);
    yield put(fetchingAllPagesForLandingStoryboardSuccedded(response, request.storyboard));
  } catch (error) {
    yield put(fetchingAllPagesForLandingStoryboardFailed(error, request.storyboard));
  }
}


/**
 * Fetch pages for interactive page
*/
export const fetchAllPagesForInteractiveStoryboard = createAction(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD, (request) => {
  return request;
});

const fetchingAllPagesForInteractiveStoryboardSuccedded = createAction(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED, (response, request) => {
  return {
    request: request,
    response: response
  }
});

const fetchingAllPagesForInteractiveStoryboardFailed = createAction(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED, (error, request) => {
  return {
    error: error,
    request: request
  };
});

function* fetchAllPagesForInteractiveStoryboardSaga(action) {
  const request = action.payload;

  let url = buildUrl(WIDGET_URL, {
    path: `/interactive/pages`,
    queryParams: request
  });

  const fetchPagesForInteractiveStoryboardAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchPagesForInteractiveStoryboardAPI);
    yield put(fetchingAllPagesForInteractiveStoryboardSuccedded(response, request));
  } catch (error) {
    yield put(fetchingAllPagesForInteractiveStoryboardFailed(error, request));
  }
}

/**
 * Initiate PPT upload 
*/
export const initiatePPTUpload = createAction(INITIATE_PPT_UPLOAD_FOR_STORYBOARD, (request) => {
  return request;
})

export const updatePPTUploadProgress = createAction(UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS, (id, progress) => {
  return {
    id: id,
    progress: progress
  }
})

export const createStoryboardFromPPT = createAction(CREATE_STORYBOARD_FROM_PPT_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  }
})

const createStoryboardFromPPTSucceeded = createAction(CREATING_STORYBOARD_FROM_PPT_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const createStoryboardFromPPTFailed = createAction(CREATING_STORYBOARD_FROM_PPT_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* createStoryboardFromPPTSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `/ppt`
  });

  const createStoryboardFromPPTAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createStoryboardFromPPTAPI);
    if (response) {
      yield put(createStoryboardFromPPTSucceeded(id, response));
    }
  } catch (error) {
    yield put(createStoryboardFromPPTFailed(id, error));
  }
}

/*
* Create Storyboard from Figma
*/
export const createStoryboardFromFigma = createAction(CREATE_STORYBOARD_FROM_FIGMA_REQUEST, (id, request, workspace) => {
  return {
    id: id,
    request: request,
    workspace: workspace
  };
})

export const createStoryboardFromFigmaSucceeded = createAction(CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response,
  };
})

export const createStoryboardFromFigmaFailed = createAction(CREATING_STORYBOARD_FROM_FIGMA_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* createStoryboardFromFigmaSaga(action) {

  const { id, request, workspace } = action.payload;

  let url = buildUrl(`${FIGMA_BASE_URL}/import`, {
  });

  const importFigmaAPI = () => {
    return axios.post(url, request, {
      headers: {
        'CS-WORKSPACE-ID': workspace
      }}).then(response => response.data);
  }

  try {
    const response = yield call(importFigmaAPI);
    if (response) {
      yield put(createStoryboardFromFigmaSucceeded(id, response));
    }

  } catch (error) {
    yield put(createStoryboardFromFigmaFailed(id, error));
  }
}

export default function* storyboardSaga() {
  yield takeEvery(CREATE_STORYBOARD_REQUEST, createStoryboardSaga);
  yield takeEvery(UPDATE_STORYBOARD_REQUEST, updateStoryboardSaga);
  yield takeEvery(FETCH_STORYBOARDS_REQUEST, fetchStoryboardsSaga);
  yield takeEvery(FETCH_STORYBOARD_REQUEST, fetchStoryboardSaga);
  yield takeEvery(DELETE_STORYBOARD_REQUEST, deleteStoryboardSaga);
  yield takeEvery(CLONE_STORYBOARD_REQUEST, cloneStoryboardSaga);
  yield takeEvery(FETCH_STORYBOARD_USERS, fetchStoryboardUsersSaga);
  yield takeEvery(ADD_USERS_TO_STORYBOARD, addUsersToStoryboardSaga);
  yield takeEvery(UPDATE_STORYBOARD_USER_ACCESS, updateStoryboardUserAccessSaga);
  yield takeEvery(REMOVE_USER_FROM_STORYBOARD, removeUserFromStoryboardSaga);
  yield takeEvery(UNPUBLISH_PAGE_REQUEST, unPublishPageSaga);
  yield takeEvery(MAKE_HOME_PAGE_FOR_STORYBOARD, makeHomePageForStoryboardSaga);
  yield takeEvery(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD, fetchAllPagesForLandingStoryboardSaga);
  yield takeEvery(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD, fetchAllPagesForInteractiveStoryboardSaga);
  yield takeEvery(CREATE_STORYBOARD_FROM_PPT_REQUEST, createStoryboardFromPPTSaga);
  yield takeEvery(CREATE_STORYBOARD_FROM_FIGMA_REQUEST, createStoryboardFromFigmaSaga);
}